import loadable from '@loadable/component';

// 懒加载组件
const SupCreditIntroduction = loadable(() => import('./supCreditIntroduction/SupCreditIntroduction'));

export const subRoutes = [
  {
    path: '/SupCreditIntroduction',
    component: SupCreditIntroduction
  }
];
